import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const SwimmingColored = ({ size = 'large' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Swimming" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M13.256 2.031h-2.624c-5.274 0-8.653 3.038-8.653 8.33l.33 3.38S5.476 12.714 12 12.714c6.524 0 9.957 1.029 9.957 1.029V10.36c0-5.29-3.428-8.329-8.701-8.329z"
                    fill="#547FFF"
                />
                <path
                    d="M21 18.784c-.692.64-2.592 2.216-4.518 2.216-1.764 0-2.134-1.177-2.134-2.165 0-.775.363-1.7 2.094-1.7 1.728 0 3.606.542 4.558.859v.79zM7.519 21C5.593 21 3.692 19.424 3 18.784v-.79c.952-.317 2.83-.859 4.559-.859 1.731 0 2.094.925 2.094 1.7 0 .988-.37 2.165-2.134 2.165zm14.851-4.639c-.125-.051-3.105-1.226-5.928-1.226-2.447 0-3.602 1.309-3.958 2.713h-.967c-.356-1.404-1.511-2.713-3.958-2.713-2.823 0-5.804 1.175-5.929 1.226a.998.998 0 0 0-.63.928v1.917c0 .256.098.501.273.687C1.393 20.02 4.246 23 7.519 23c2.523 0 3.686-1.535 4.018-3.152h.927C12.796 21.465 13.959 23 16.482 23c3.273 0 6.125-2.98 6.245-3.107.175-.186.273-.431.273-.687v-1.917a.998.998 0 0 0-.63-.928zM21 12.556c-1.679-.361-4.895-.907-9-.907-4.104 0-7.32.546-8.999.907V10.71c0-4.251 3.445-7.71 7.68-7.71h2.639C17.555 3 21 6.459 21 10.71v1.846zM13.32 1h-2.639c-5.337 0-9.68 4.356-9.68 9.71v3.117a1 1 0 0 0 1.277.961c.04-.012 4.022-1.139 9.722-1.139 5.701 0 9.683 1.127 9.723 1.139A1 1 0 0 0 23 13.827V10.71C23 5.356 18.657 1 13.32 1z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
